import React, { useEffect, useState } from "react";
import { DateTimePicker } from "@mui/x-date-pickers/DateTimePicker";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import TextField from "@mui/material/TextField";
import dayjs from "dayjs";
import { DatePicker } from "@mui/x-date-pickers";

export default function CustomizeDatePicker({
  key,
  value: initialValue,
  onChange: handleChange,
  error = false,
  helperText = "",
  ...props
}) {
  const [value, setValue] = useState(null);

  useEffect(() => {
    console.log("initialValue", initialValue);
    if (initialValue) {
      setValue(dayjs(initialValue));
    } else {
      setValue(null);
    }
  }, [initialValue]);

  return (
    <LocalizationProvider dateAdapter={AdapterDayjs} key={key}>
      <DatePicker
        {...props}
        onChange={(newValue) => {
          setValue(newValue);
          if (handleChange) {
            handleChange(newValue ? newValue.format("YYYY-MM-DD") : null);
          }
        }}
        format="DD/MM/YYYY"
        slotProps={{
          textField: {
            fullWidth: true,
            placeholder: "เลือกวันที่",
            inputProps: { readOnly: props.readOnly, disabled: props.disabled },
            sx: {
              "& .MuiInputBase-root": {
                height: "40px",
                bgcolor: "white",
              },
            },
            error: error,
            helperText: helperText,
          },
        }}
        value={value}
      />
    </LocalizationProvider>
  );
}
